module.exports = __webpack_public_path__ + "img/ssb_menu17.42fb1ca3.png";